import { RouterProvider } from 'react-router-dom';
import { router } from 'src/actuators/router';
import { memo } from 'react';

export const AppActuators = memo(() => {
    const composeRouter = router();
    return <RouterProvider router={composeRouter}/>;
});
